import { StatusColumnType, TableRow } from '@shared/components/data-list/common';

export type ProgressPaymentTabInstance = {
  document_payment?: number;
  document_submitted: string;
  document_total?: number;
  entity_instance_id: number;
  parent_entity_instance_id: number;
  progress_payment_end_date: string;
  progress_payment_id: number;
  progress_payment_number: string;
  payment_period_id: number;
  progress_payment_start_date: string;
  state_color: string;
  state_name: string;
  state_text_color: string;

  /** used internally, composed from start and end dates */
  progress_payment_period: string;
};

export type ProgressPaymentTabRow = TableRow &
  ProgressPaymentTabInstance & {
    state_name: StatusColumnType;
  };
